import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = { class: "h-100 d-flex align-content-start" }
const _hoisted_3 = {
  class: "col-md-6 h-100 pl-md-4",
  id: "team-info"
}
const _hoisted_4 = { class: "props-panel" }
const _hoisted_5 = { class: "ml-2 align-self-center" }
const _hoisted_6 = {
  class: "collapse",
  id: "props-panel-collapse"
}
const _hoisted_7 = {
  id: "props-card",
  class: "card card-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TeamList = _resolveComponent("TeamList")!
  const _component_TeamInfo = _resolveComponent("TeamInfo")!
  const _component_TeamPropertiesPane = _resolveComponent("TeamPropertiesPane")!
  const _component_ProjectPropertiesPane = _resolveComponent("ProjectPropertiesPane")!
  const _component_vue_draggable_resizable = _resolveComponent("vue-draggable-resizable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TeamList, { ref: "teamList" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TeamInfo, { ref: "teamInfo" }, null, 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "d-flex titlebar",
        "data-toggle": "collapse",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.collapse && _ctx.collapse(...args))),
        href: "#props-panel-collapse"
      }, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.title), 1),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-fill" }, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("button", {
          id: "collapse-btn",
          class: "btn btn-outline-secondary btn-collapse align-self-start",
          "data-toggle": "collapse",
          href: "#props-panel-collapse",
          role: "button",
          "aria-expanded": "false",
          title: "Collapse"
        }, [
          _createElementVNode("i", { class: "fas fa-chevron-up rotate" })
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_vue_draggable_resizable, {
          class: "w-100 no-transform",
          "prevent-deactivation": true,
          active: true,
          draggable: false,
          onResizing: _ctx.onResize,
          "max-height": _ctx.propsMaxH,
          h: _ctx.propsH,
          handles: ['tm'],
          "class-name-handle": "handle"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createVNode(_component_TeamPropertiesPane, {
                "on-edit-refresh": _ctx.onEditTeam,
                "on-remove-refresh": _ctx.onRemoveTeam,
                team: _ctx.team,
                ref: "teamProperties"
              }, null, 8, ["on-edit-refresh", "on-remove-refresh", "team"]), [
                [_vShow, _ctx.team !== null]
              ]),
              _withDirectives(_createVNode(_component_ProjectPropertiesPane, {
                project: _ctx.project,
                ref: "projectProperties"
              }, null, 8, ["project"]), [
                [_vShow, _ctx.project !== null]
              ])
            ])
          ]),
          _: 1
        }, 8, ["onResizing", "max-height", "h"])
      ])
    ])
  ]))
}